import styled from 'styled-components'
import AppButton from 'Components/AppButton'
import { PRIMARY_SECONDARY_COLOR } from '@CSSVars/colors'
import { BREAK_POINT_MD } from '@CSSVars/variables'
import SvgIcon from 'Components/SvgIcon'

export const _MortgageCTA = styled(AppButton)`
width: 275px;
  height: 44px;
  padding: 0 12px;
  margin: 8px 0;
  position: relative;
  border: 1px solid ${PRIMARY_SECONDARY_COLOR};
  background-color: ${PRIMARY_SECONDARY_COLOR}10;
  border-radius: 10px;
  display: flex;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: start;

  span {
    font-weight: 600;
    text-decoration: underline;
    margin-right: 18px;
  }

  .tooltipTrigger {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    color: transparent;
    border-color: transparent;
  }

  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    opacity: .1;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    justify-content: center;
  }

`

export const _MortgageIcon = styled(SvgIcon)`
    height: 16px;
    width: 16px;
    margin-right: 12px;
    margin-left: 6px;
    path {
      fill:${PRIMARY_SECONDARY_COLOR};
    }

`

export const _ArrowIcon = styled(SvgIcon)`
    transform: scale(-1);
    position: absolute;
    right: 18px;


`

export const _MortgageText = styled.div`


`
